import {ChevronLeft, ChevronRight, RefreshCw, Users} from "lucide-react";
import {motion} from "framer-motion";
import React from "react";
import { Select } from "./Select";
import { COUNTRIES } from "../constants/countries";

const TeamsView = ({
  teams,
  filters,
  onFilterChange,
  leagues,
  seasons,
  loading,
  onRefresh,
  pagination,
  onPageChange,
  t
}) => (
  <div className="space-y-6">
    {/* Teams Grid */}
    <div className="border border-white/10 rounded-sm bg-white/[0.02]">
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-black uppercase tracking-tight text-white flex items-center gap-3">
            {t('Teams')} ({teams.length})
          </h2>
          {pagination.totalPages > 1 && (
            <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-gray-500">
              {t('Page')} {pagination.currentPage} {t('of')} {pagination.totalPages}
            </div>
          )}
        </div>
      </div>

      {loading ? (
        <div className="p-12 text-center">
          <RefreshCw className="animate-spin mx-auto mb-4 text-white" size={32} />
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-gray-400">{t('Loading teams...')}</p>
        </div>
      ) : teams.length === 0 ? (
        <div className="p-12 text-center">
          <Users className="mx-auto mb-4 text-gray-600" size={36} />
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-gray-500">{t('No teams found')}</p>
          <p className="text-[11px] font-mono uppercase tracking-widest text-gray-600 mt-2">
            {t('Try adjusting your filters')}
          </p>
        </div>
      ) : (
        <>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {teams.slice(
                (pagination.currentPage - 1) * pagination.perPage,
                pagination.currentPage * pagination.perPage
              ).map((team, index) => (
                <motion.div
                  key={team.id || index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="border border-white/10 rounded-sm p-5 bg-white/[0.03] hover:border-white/40 transition-all duration-200"
                >
                  <div className="text-center">
                    {team.logo && (
                      <img
                        src={team.logo}
                        alt={team.name}
                        className="w-16 h-16 mx-auto mb-4 rounded-full object-cover border border-white/20 bg-black/60"
                      />
                    )}
                    <h3 className="font-black text-lg text-white uppercase tracking-tight mb-1">
                      {team.name}
                    </h3>
                    {team.country && (
                      <p className="text-[11px] font-mono uppercase tracking-widest text-gray-500 mb-4">
                        {team.country.name || team.country}
                      </p>
                    )}
                    <div className="border border-white/10 rounded-sm p-3 bg-black">
                      <div className="text-[10px] font-mono uppercase tracking-widest text-gray-500 mb-1">
                        {t('Team ID')}
                      </div>
                      <div className="text-xl font-black text-white">{team.id}</div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Pagination */}
          {pagination.totalPages > 1 && (
            <div className="p-6 border-t border-white/10 flex justify-center">
              <div className="flex items-center gap-3">
                <button
                  onClick={() => onPageChange(pagination.currentPage - 1)}
                  disabled={pagination.currentPage === 1}
                  className="px-3 py-2 border border-white/10 text-white text-xs font-mono uppercase tracking-widest rounded-sm bg-transparent hover:border-white/30 disabled:opacity-40 transition-all"
                >
                  <ChevronLeft size={18} />
                </button>

                <span className="px-4 py-2 text-xs font-mono uppercase tracking-[0.3em] text-gray-400">
                  {pagination.currentPage} / {pagination.totalPages}
                </span>

                <button
                  onClick={() => onPageChange(pagination.currentPage + 1)}
                  disabled={pagination.currentPage === pagination.totalPages}
                  className="px-3 py-2 border border-white/10 text-white text-xs font-mono uppercase tracking-widest rounded-sm bg-transparent hover:border-white/30 disabled:opacity-40 transition-all"
                >
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  </div>
);

export default TeamsView;
